import * as React from 'react';
import TutorialsTab from './TutorialsTab';
import PresentationsTab from './PresentationsTab';

const ManualTab = ({ activeChildTab }) => (
  <>{activeChildTab === 0 ? <PresentationsTab /> : activeChildTab === 1 ? <TutorialsTab /> : ''}</>
);
export default ManualTab;
